var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card-body position-relative p-0",
      attrs: { id: _vm.id + "-container" },
    },
    [
      _c("div", { class: _vm.spaceClasses }, [
        _c(
          "div",
          { class: _vm.groupClass },
          [
            _c("h6", { staticClass: "font-xs text-light-gray mb-0" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("boards.actions.selectBoard")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "material-input",
              {
                staticClass: "no-border",
                attrs: { "no-label": "" },
                model: {
                  value: _vm.defaultValue,
                  callback: function ($$v) {
                    _vm.defaultValue = $$v
                  },
                  expression: "defaultValue",
                },
              },
              [
                _c("v-select-field", {
                  staticClass: "simple-dd no-span",
                  attrs: {
                    placeholder: _vm.$t("boards.actions.selectBoard"),
                    options: _vm.vSelectOptions,
                    "default-value": _vm.defaultValue,
                    clearable: _vm.clearable,
                    scenario: "board",
                  },
                  on: { "option:selected": _vm.handleChange },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }